import { AnimatePresence, AnimationPlaybackControls, motion } from "framer-motion";
import { useRef, useState } from "react";
import { createPortal } from "react-dom";
import useOutsideClick from "../Hooks/useOutsideClick";

interface Props {
    index: number;
    animationRef: React.RefObject<AnimationPlaybackControls | null>;
}

const titles: Array<string> = [
    "Utrwalanie właściwej wymowy z wykorzystaniem gier i zabawek",
    "Wykorzystywanie atrakcyjnych dla dzieci metod",
    "Rozwijanie zdolności szkolnych z wykorzystaniem ruchu",
    "Zabawy sensoryczne na zajęciach grupowych",
    "Zabawy sensoryczne na zajęciach ruchowych",
    "Elektrostymulacja logopedyczna",
    "Terapia manualna"
]

const Card: React.FC<Props> = (props) => {
    let [showOverlay, setShowOverlay] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);
    const ref = useRef<HTMLDivElement>(null);
    useOutsideClick({ref: ref, callback: () => toggleSize()});

    const toggleSize = () => {
      isExpanded ? props.animationRef.current?.play() : props.animationRef.current?.pause();
      setIsExpanded(!isExpanded);
    };

    return (
        <>
            <motion.div 
                 key={props.index} 
                 className="card md:w-[200px] md:h-[200px] w-[150px] h-[150px] shadow-[0_10px_10px_rgba(0,0,0,0.5)] hover:shadow-[0_15px_15px_rgba(0,0,0,0.5)]" 
                 onHoverStart={() => {props.animationRef.current?.pause(); setShowOverlay(true)}} 
                 onHoverEnd={() => {!isExpanded && props.animationRef.current?.play(); setShowOverlay(false)}} 
                 whileHover={{scale: 1.05, boxShadow: "0 15px 15px rgba(0,0,0,0.5)"}}
                 onClick={() => toggleSize()}>
                 <AnimatePresence>
                     {showOverlay && <motion.div className="card-overlay" initial={{opacity: 0}} animate={{opacity: 0.5}} exit={{opacity: 0}}/>}
                 </AnimatePresence>
                 <img src={`/Gallery/${props.index}.jpg`} alt='card'/>
             </motion.div>
        {createPortal(
        <>
            <AnimatePresence>
                {isExpanded && 
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    className="fixed inset-0 bg-black/20 h-full w-full z-10"
                /> }
            </AnimatePresence>
            <AnimatePresence>
                {isExpanded && 
                <div className="fixed inset-0 grid place-items-center z-[100]">
                    <motion.div
                    ref={ref}
                    initial={{scale: 0}} 
                    animate={{scale: 1}} 
                    exit={{scale: 0}}
                    transition={{duration: 0.3}}
                    className="sm:max-w-[600px] sm:max-h-[600px] flex flex-col bg-slate-100 sm:rounded-3xl overflow-hidden relative shadow-[0_15px_15px_rgba(0,0,0,0.5)]"
                    >
                    <motion.button 
                        type="button" 
                        className="absolute w-7 h-7 top-3 right-3 bg-white/75 hover:bg-white/90 rounded-full grid place-items-center"
                        onClick={() => toggleSize()}
                        whileHover={{ rotate: 90 }}
                        transition={{ type: "spring", stiffness: 500, damping: 20 }}> 
                            <img src="/icons/close.svg" className="w-5 h-5" />
                    </motion.button>
                    <img src={`/Gallery/${props.index}.jpg`} alt='card'
                        className="w-[500px] sm:max-w-[500px] sm:max-h-[500px] sm:rounded-tr-lg sm:rounded-tl-lg object-fit object-top"
                    />
        
                    <div className="flex flex-col justify-start items-start p-2 absolute bottom-0 w-full bg-black/50">
                        <motion.h2 
                            className="font-medium self-center text-white text-2xl sm:max-w-[450px] text-center"
                            initial={{ opacity: 0, x: -100 }}
                            animate={{ opacity: 1, x: 0 }}
                            exit={{ opacity: 0, x: -100 }}
                            transition={{ type: "tween", delay: 0.2}}>
                            {titles[props.index]}
                        </motion.h2>
                    </div>
                    </motion.div>
                </div>
                }
            </AnimatePresence>
        </>, document.body)}
    </>
    )
};

export default Card;